import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import ContentLayout from "../../../../partials/content/ContentLayout";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import Illustration from "../../../../partials/content/Illustration";
import DialogLayout from "../../../../partials/content/DialogLayout";
import PlantForm from "./PlantForm";
import {
  deletePlant,
  getPlant,
  getPlants,
} from "../../../../services/production/productionService";

function PlantList({ history }) {
  const [plants, setPlants] = useState([]);
  const [plantID, setPlantID] = useState(0);
  const [openPlantForm, setOpenPlantForm] = useState(false);
  const getPlantsData = async () => {
    const response = await getPlants();
    const { data } = response.data;
    setPlants(data.plants);
  };
  useEffect(() => {
    getPlantsData();
  }, []);
  return (
    <React.Fragment>
      <PageSubHeader
        title="Plant List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/production/plants",
            title: "Plants",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/menu");
            },
          },
          {
            title: "New Plant",
            color: "primary",
            icon: "fas fa-plus-circle",
            onClick: () => {
              setOpenPlantForm(true);
            },
          },
        ]}
      />
      <ContentLayout>
        {plants.length ? (
          <CustomDataTable
            data={plants}
            //dataDetailColumns={warehouseDetailColumn}
            onRefreshData={() => {
              //this.getWarehousesData();
            }}
            tableName="warehouse"
            selectionMode="checkbox"
            columns={[
              {
                selectionMode: "multiple",
              },
              {
                header: "Plant ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Plant Name",
                field: "plantName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.plantName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Phone Number",
                field: "addressPhone",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.addressPhone}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "City",
                field: "city",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.city} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Edit Plant">
                      <button
                        type="button"
                        onClick={(event) => {
                          setPlantID(rowData.ID);
                          setOpenPlantForm(true);
                        }}
                        className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                    </BootstrapTooltip>
                    <BootstrapTooltip title="Delete Plant">
                      <button
                        type="button"
                        onClick={(event) => {
                          handleDeletePlant(rowData.ID);
                        }}
                        className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        ) : (
          <Illustration
            imageSource="INVIFO Inventory.png"
            description="Hooray! You're ready to have your first Plant!"
            guidance="Hint: manage your warehouses to simplify daily operational"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        )}
      </ContentLayout>
      <DialogLayout
        open={openPlantForm}
        title="Plant Form"
        onCloseDialog={() => {
          setOpenPlantForm(false);
        }}
        maxWIdth="md"
      >
        <PlantForm
          plantID={plantID}
          onConfirmSave={() => {
            setOpenPlantForm(false);
          }}
          onCloseDialog={() => {
            setOpenPlantForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
  function handleDeletePlant(plantID = 0) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Plant ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deletePlant(plantID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getPlantsData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }
}

export default PlantList;
